import React from "react";

const DigitalAuditWorkflowsSection =() =>{
    return(
        <>
      <section className="container  text-center pb-2 mt-n5 pt-n5 mt-md-4 ">
          <h2 className="h1 pt-0 pt-md-5">Real-time Digital Inspection and Auditing Workflows</h2>
          <div className="row justify-content-center mb-md-2 mb-lg-5">
            <div className="col-md-10">
              <p className="fs-lg mb-lg-0">Experience unprecedented efficiency in NDE operations. Orbix real-time digital workflows slash audit cycle times by 99% and reduce skilled resource waste by up to 90%. Field data uploads instantly to the cloud, enabling immediate remote inspection and auditing This level of optimization transforms your operations, enabling rapid decision-making and significant resource savings.</p>
            </div>
          </div>
          
        </section>
       

        </>
    )

}

export default DigitalAuditWorkflowsSection;